
  <template>
  <div class="main-source">
    <template v-for="(s, index) in mainSourcesRegistry">
      <button
        class="main-source__button"
        :class="{ selected: mainSource === s.key }"
        @click="mainSourceClick(s.key)"
        :key="index"
      >
        {{ s.name.toUpperCase() }}
      </button>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "FilterMainSource",
  computed: {
    ...mapGetters({
      mainSourcesRegistry: "ui/mainSourcesRegistry",
      mainSource: "ui/mainSource",
    }),
  },

  methods: {
    mainSourceClick(key) {
      this.setMainSource(key);
      this.$router.push("/" + key);
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
      calcData: "data/calcData",
    }),
  },
};
</script>

<style lang="scss" scoped>
.main-source {
  height: 100%;

  display: flex;
  &__button {
    @include filter-button;
  }
}
</style>